export const groupType = {
  ALL: 'all',
  GROUP: 'group',
  SINGLE: 'single'
};

export const groupLabelMap = {
  ALL: 'All',
  GROUP: 'Conf',
  SINGLE: 'Se'
};

export const sortBy = {
  skuID: 'skuID',
  quantity: 'quantity',
  subtotal: 'subtotal',
  deliveryDate: 'deliveryDate',
  none: 'none'
};

export const pendingState = {
  empty: '',

  pending: {
    qty: 'cart-pending--qty',
    remove: 'cart-pending--remove'
  },

  error: {
    qty: 'cart-error-qty'
  }
};

export const LABELS_API_PATH = '/experience-my-products';

export const DEFAULT_PATH = '/';

export const enum exportType {
  MY_PRODUCTS_EXCEL = 'excel',
  MY_PRODUCTS_PDF = 'pdf',
  MY_PRODUCTS_PDS_PDF = 'pdfDatasheet',
  MY_PRODUCTS_XML = 'xml'
}

export const exportPaths = {
  [exportType.MY_PRODUCTS_PDF]: {
    path: '/myproducts/download-pdf'
  },
  [exportType.MY_PRODUCTS_PDS_PDF]: {
    path: '/myproducts-pds/download-pdf'
  },
  [exportType.MY_PRODUCTS_XML]: {
    path: '/xml-export'
  }
};

export const pillsNamePrefix = 'giftlistPills';

export const MAX_PRODUCT_QTY = 99999;

export const MOBILE_INTEND = 10;

export const REMOVE = 'REMOVE';

export const REMOVE_FROM_COMPARE = 'REMOVE_FROM_COMPARE';

export const MAX_PRODUCTS = 'MAX_PRODUCTS';

export const ADD = 'ADD';

export const ADD_TO_COMPARE = 'ADD_TO_COMPARE';

export const ADD_FROM_RELATED_PRODUCT = 'ADD_FROM_RELATED_PRODUCT';

export const REPLACE_QTY = '#number of items#';

export const REPLACE_NUMBER_OF_FILES = '(#number of files#)';

export const hideEventsArr = ['mousedown', 'touchstart', 'scroll', 'resize'];

export const notifyTime = process.env.NODE_ENV === 'test' ? 10 : 2000;

export const CROSS_SELL_GROUP_ID = 'CrossSell';

export const lazyRenderOffset = 300;

export const lazyPlaceholderHeight = 110;

export const lazyPlaceholderHeightMobile = 204;

export const debounceTime = process.env.NODE_ENV === 'test' ? 5 : 500;

export const substitute = 'substitute';

export const exportAllHivesURL = '/xml-export';

export const BSL_IMAGE_SIZE_RENDITION_MAP = {
  64: 'rendition_64_gif',
  113: 'rendition_113_png',
  200: 'rendition_200_png',
  288: 'rendition_288_png',
  369: 'rendition_369_jpg'
};

export const EMPTY_VALUE = '';

export const RESPONSE_STATUS = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING'
};

export enum DIR {
  ltr = 'ltr',
  rtl = 'rtl'
}

export const RELATED_PRODUCTS_SLIDER = {
  initialValue: 0,
  step: 1,
  desktopProductsMax: 3,
  mobileProductsMax: 2,
  cardWidth: 220,
  transitionStyle: 'transform 0.2s ease-in-out 0s'
}

export const DELETE_ALL = 'all';

export enum ProductSelectors {
  CODIFICATION = 'co'
}